import { render } from "./RealTimeDetailModal.vue?vue&type=template&id=697150a0"
import script from "./RealTimeDetailModal.vue?vue&type=script&lang=ts"
export * from "./RealTimeDetailModal.vue?vue&type=script&lang=ts"

import "./RealTimeDetailModal.vue?vue&type=style&index=0&id=697150a0&lang=css"
script.render = render

export default script